import ModalConfirmContainer from './containers/ModalConfirmContainer';

export default ModalConfirmContainer;
